<div nz-flex [nzGap]="'small'" [nzVertical]="true">
  <div>
    <div class="header-wrapper">
      <h1>Lista kodów {{ title() }}</h1>
      <button nz-button nzType="primary" (click)="createClick()">
        <nz-icon nzType="plus-circle" nzTheme="outline" />
        Dodaj kod {{ title() }}
      </button>
    </div>
    <div nz-flex [nzGap]="'small'" [nzVertical]="false">
      <div>
        <button nz-button nz-dropdown [nzDropdownMenu]="menu">
          {{
            filters().isVerified === null
              ? 'Wszystkie'
              : filters().isVerified
                ? 'Zweryfikowane'
                : 'Niezweryfikowane'
          }}
          <nz-icon nzType="down" />
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item (click)="filters.update((f) => ({ ...f, isVerified: true }))">
              Zweryfikowane
            </li>
            <li nz-menu-item (click)="filters.update((f) => ({ ...f, isVerified: false }))">
              Niezweryfikowane
            </li>
            <li nz-menu-item (click)="filters.update((f) => ({ ...f, isVerified: null }))">
              Wszystkie
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>

      <input
        nz-input
        placeholder="Szukaj po kodzie lub nazwie..."
        [ngModel]="filters().query"
        (ngModelChange)="queryChange($event)"
        class="search-input"
      />
    </div>
  </div>

  <nz-table
    #codesTable
    class="icd-codes-table"
    [nzData]="searchResult()?.results ?? []"
    [nzBordered]="true"
    [nzLoading]="loading()"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageIndex"
    [nzTotal]="total"
    [nzFrontPagination]="false"
    (nzQueryParams)="onQueryParamsChange($event)"
    nzTableLayout="fixed"
  >
    <thead>
      <tr>
        <th nzColumnKey="id" [nzSortFn]="true" [nzSortOrder]="'descend'">Id</th>
        <th nzColumnKey="code" [nzSortFn]="true">Kod</th>
        <th nzColumnKey="name" [nzSortFn]="true">Nazwa</th>
        <th nzColumnKey="isVerified" [nzSortFn]="true" class="mhs-center">Zweryfikowany</th>
        <!-- <th nzColumnKey="modifiedByUser" [nzSortFn]="true">Zmodyfikował</th>
        <th nzColumnKey="modifyDate" [nzSortFn]="true">Data modyfikacji</th> -->
        <th class="mhs-table-action-header">Akcja</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of codesTable.data">
        <td>{{ data.id }}</td>
        <td>
          <nz-tag nzColor="blue">{{ data.code }}</nz-tag>
        </td>
        <td>{{ data.name }}</td>
        <td>
          <div
            class="mhs-boolean-icon"
            [attr.aria-label]="data.isVerified ? 'Tak' : 'Nie'"
            [title]="data.isVerified ? 'Tak' : 'Nie'"
          >
            <nz-icon [nzType]="data.isVerified ? 'check' : 'close'" />
          </div>
        </td>
        <!-- <td>{{ data.modifiedByUser }}</td>
        <td>{{ data.modifyDate | date: 'dd.MM.yyyy HH:mm' }}</td> -->
        <td class="mhs-table-actions-cell">
          <div
            class="mhs-table-actions"
            nz-flex
            [nzGap]="'small'"
            [nzVertical]="false"
            [nzJustify]="'end'"
          >
            <button nz-button nzType="primary" nzShape="circle" (click)="detailsClick(data.code!)">
              <nz-icon nzType="search" />
            </button>
            <a
              nz-dropdown
              [nzDropdownMenu]="userActionsMenu"
              nz-button
              nzType="default"
              nzShape="circle"
            >
              <nz-icon nzType="menu-fold" nzTheme="outline" />
            </a>
            <nz-dropdown-menu #userActionsMenu="nzDropdownMenu">
              <ul nz-menu>
                <li *ngIf="isIcd10CodeType()" nz-menu-item (click)="editClick(data.code!)">
                  Edytuj
                </li>
                <li *ngIf="isIcd10CodeType()" nz-menu-item (click)="showManageMetaClick(data.id!)">
                  Zarządzaj metadanymi
                </li>
                <li
                  nz-menu-item
                  (click)="verifyClick(data.id!)"
                  [nzDisabled]="isUserActionsDisabled(data)"
                >
                  Zweryfikuj
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
